import { Metamodel } from '../base/model';
import { SalesforceServiceCloudV2Dataset } from '../dataset/salesforce-service-cloud-v2.dataset';
import { ModelConstants } from '../model-constants';
import { SalesforceV2CopySource } from './salesforce-v2.copysource';

@Metamodel.model({
    name: ModelConstants.salesforceServiceCloudV2CopySource,
    display: [],
    tags: { datasetModel: Metamodel.modelFor(SalesforceServiceCloudV2Dataset) }
})
export class SalesforceServiceCloudV2CopySource extends SalesforceV2CopySource {
}
